/**
 * Formats a percent split side's value as `62.4%` (always one decimal, via
 * `toFixed`, so `62.45` rounds to `62.5%`). Negatives pass through with the sign
 * (`-3.1%`). Count and currency sides are passed to KpiTile as raw numbers so it
 * owns that formatting (locale, thousands separators, currency prefix) in one
 * place, app-wide.
 */
export const formatPercentValue = (value: number): string =>
    `${value.toFixed(1)}%`;
